module.exports = __webpack_public_path__ + "static/media/links-optimized.790ea8b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/99-conclusion/images/links-optimized.jpg
// module id = 986
// module chunks = 0